import {
  computedPbxBasePlans,
  computedPbxNonBasePlans,
  computedPbxPlans,
  computedPbxTollFreePlans,
  computedPbxUSAUPlans,
} from '@/common/service/computers/plans/pbx';
import _ from 'lodash';

const state = {
  pbxBillingCycle: '',
  pbxBasePlanCode: '',
  pbxCallingPlan: '',
};

const getters = {
  allPbxPlans(state, getters) {
    return computedPbxPlans(getters.planMapFlat);
  },
  allPbxBasePlans(state, getters) {
    return computedPbxBasePlans(getters.planMapFlat);
  },
  selectedAllPbxPlans(state, getters) {
    return computedPbxPlans(getters.getSelectedPlans);
  },
  selectedPbxNonBasePlans(state, getters) {
    return computedPbxNonBasePlans(getters.getSelectedPlans);
  },
  selectedPbxBasePlans(state, getters) {
    return computedPbxBasePlans(getters.selectedAllPbxPlans);
  },
  selectedPbxBasePlan(state, getters) {
    return _.get(getters.selectedPbxBasePlans, [0]);
  },
  selectedPbxUSAUPlans(state, getters) {
    return computedPbxUSAUPlans(getters.selectedAllPbxPlans);
  },
  selectedTFPlans(state, getters) {
    return computedPbxTollFreePlans(getters.selectedAllPbxPlans);
  },
  selectedTFPlan(state, getters) {
    return _.get(getters.selectedTFPlans, [0]);
  },
  pbxBasePlansGroupByBillingCycle(state, getters) {
    const {
      annual = [],
      monthly = [],
      quarterly = [],
      two_years = [],
      three_years = [],
      payAsYouGo = [],
    } = _.groupBy(getters.allPbxBasePlans, 'billing_cycle');
    return {
      monthly: [...payAsYouGo, ...monthly],
      annual: [...payAsYouGo, ...annual],
      quarterly: [...payAsYouGo, ...quarterly],
      two_years: [...payAsYouGo, ...two_years],
      three_years: [...payAsYouGo, ...three_years],
    };
  },
  boughtPbxBasePlan(state, getters) {
    return computedPbxBasePlans(getters.boughtPlans)?.[0];
  },
  pbxBaseInfo(state) {
    return {
      billingCycle: state.pbxBillingCycle,
      basePlanCode: state.pbxBasePlanCode
    }
  },
  pbxCallingPlanType(state){
    return state.pbxCallingPlan
  }
};

const mutations = {
  setPbxBillingCycle(state, cycle) {
    state.pbxBillingCycle = cycle;
  },
  setPbxCallingPlan(state, type) {
    state.pbxCallingPlan = type;
  },
  setPbxBasePlanCode(state, planCode) {
    state.pbxBasePlanCode = planCode;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
